// src/components/FooterNote.jsx
import React from 'react';

const FooterNote = ({ text }) => (
  <p className="text-sm mt-6 text-gray-600 text-center">{text}</p>
);

export default FooterNote;
